import type { CalculatorMeta } from "../../types/calculator";

const meta: CalculatorMeta = {
  route: "/engine-horsepower-calculator",
  component: () => import("../../routes/EngineHorsepowerCalculator.svelte"),
  card: {
    id: "engine-horsepower-calculator",
    title: "Engine Horsepower Calculator",
    description:
      "Calculate horsepower, torque, or RPM using the dyno formula HP = T × RPM ÷ 5252. Includes 10 engine presets (Civic Si, Mustang GT, 911 GT3, Ferrari 488, Chiron) and metric/imperial unit toggle.",
    icon: "directions_car",
    iconBgClass: "bg-red-50",
    iconTextClass: "text-red-600",
    href: "/engine-horsepower-calculator",
    category: "Physics & Science",
  },
  seo: {
    title: "Engine Horsepower Calculator – HP = Torque × RPM ÷ 5252",
    description:
      "Free engine horsepower calculator using the dyno formula HP = (Torque × RPM) / 5252. Solve for horsepower, torque, or RPM given any two — supports imperial (lb-ft, HP) and metric (N·m, kW) units. Includes 10 famous engine presets for quick comparison.",
  },
};

export default meta;
